import { root } from './roles';

export const roles = {
  ...root,
};
